module.exports = __webpack_public_path__ + "img/notify.b977e28a.png";